import React, { useRef, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";

import "./Home.css";
import { BsArrows } from "react-icons/bs";
import { Col, Container, Row } from "react-bootstrap";

import { Autoplay } from "swiper/modules";

const AfterSurgery = () => {
  const dataImage = [
    {
      url: "/Images/r1.jpeg",
    },
    {
      url: "/Images/r2.jpeg",
    },
    {
      url: "/Images/g1.jpeg",
    },
    {
      url: "/Images/g2.jpeg",
    },
    {
      url: "/Images/l1.jpeg",
    },
    {
      url: "/Images/l2.jpeg",
    },
  ];
  const rino = [
    {
      url: "/Images/r1.jpeg",
    },
    {
      url: "/Images/r2.jpeg",
    },
    {
      url: "/Images/r3.jpeg",
    },
    {
      url: "/Images/r4.jpeg",
    },

    {
      url: "/Images/r5.jpeg",
    },
    {
      url: "/Images/r6.jpeg",
    },
    {
      url: "/Images/r7.jpeg",
    },
    {
      url: "/Images/r8.jpeg",
    },

    {
      url: "/Images/r9.jpeg",
    },
  ];
  const gyno = [
    {
      url: "/Images/g1.jpeg",
    },
    {
      url: "/Images/g2.jpeg",
    },
    {
      url: "/Images/g3.jpeg",
    },
    {
      url: "/Images/g4.jpeg",
    },

    {
      url: "/Images/g5.jpeg",
    },
    {
      url: "/Images/g6.jpeg",
    },
    {
      url: "/Images/g7.jpeg",
    },
  ];
  const lipo = [
    {
      url: "/Images/l1.jpeg",
    },
    {
      url: "/Images/l2.jpeg",
    },
    {
      url: "/Images/l3.jpeg",
    },
    {
      url: "/Images/l4.jpeg",
    },

    {
      url: "/Images/l5.jpeg",
    },
    {
      url: "/Images/l6.jpeg",
    },
    {
      url: "/Images/l7.jpeg",
    },
  ];
  const ortho=[
    {url:"/Images/ortho2.jpg"},
    {url:"/Images/optho2.avif"}
    ,  {url:"/Images/optho3.avif"}
  ]
  const [active, setActive] = useState(0);
  return (
    <div style={{ overflow: "hidden" }} className="before_after_main_container">
      <Row>
        <Col className="main_col_after">
          <h5
            className="we_offer_home_h5"
            style={{ textAlign: "center", textTransform: "uppercase" }}
          >
            {/* Look at the difference <br /> */}
            before and after procedures
          </h5>
          <div className="we_offer_home_divs" style={{ textAlign: "center" }}>
            Surgery Saathi enhances relaxation during recovery from
            rhinoplasty, Opthalmologist, Hair transplant, gynaecomastia surgery,
            and lipoma removal, promoting comfort and emotional well-being.
          </div>
        </Col>
      </Row>
      <div className="wpb_wrapper">
        {/* <div className="afterSurgery-headings" id="like_sc_header_530863701">
          <h2
            className=""
            style={{
              visibility: "visible",
              transform: "scale(1)",
              opacity: 1,
              transition: "0.3s",
            }}
          >
            <span> Look at the difference </span>
            <br />
            before and after procedures
          </h2>
        </div> */}
        {/* <div
          className="after-surgery-content-width col-align-center"
          style={{ maxWidth: 770 }}
        >
          <p style={{ textAlign: "center" }}>
            Surgery Saathi enhances relaxation during recovery from rhinoplasty,
            gynaecomastia surgery, and lipoma removal, promoting comfort and
            emotional well-being.
          </p>
        </div> */}
        <div className="ltx-before-after " id="like_sc_before_after_1831218595">
          <ul className="cats tabs-cats ltx-ba-filter">
            <li>
              <span
                className={`cat ${active === 0 ? "cat-active" : ""}`}
                onClick={() => setActive(0)}
              >
                Rhinoplasty
              </span>
            </li>
            <li>
              <span
                className={`cat ${active === 1 ? "cat-active" : ""}`}
                onClick={() => setActive(1)}
              >
                Gynaecomastia
              </span>
            </li>
            <li>
              <span
                className={`cat ${active === 2 ? "cat-active" : ""}`}
                onClick={() => setActive(2)}
              >
                lipoma removal
              </span>
            </li>
            <li>
              <span
                className={`cat ${active === 3 ? "cat-active" : ""}`}
                onClick={() => setActive(3)}
              >
                Ophthalmology
              </span>
            </li>
          </ul>
          <div className="ltx-wrap">
            <div className="container">
              <div className="row">
                <div className="col-lg-3 hidden-md hidden-sm hidden-ms hidden-xs procedure-surgeryy">
                  <h6 className="header">
                    before <span> procedures </span>
                  </h6>
                </div>
                <div className="col-lg-6">
                  <div
                    className="ltx-ba-wrap ltx-ba-filter-0 active"
                    style={{ display: "block" }}
                  >
                    {active === 0 && (
                      <Swiper
                        className="mySwiper"
                        autoplay={{
                          delay: 1500,
                          disableOnInteraction: false,
                        }}
                        modules={[Autoplay]}
                      >
                        {rino.map((item) => (
                          <SwiperSlide>
                            <img
                              src={item.url}
                              className="ltx-ba-before"
                              alt="Face surgery"
                            />
                            {/* <div className="handle">
                            <BsArrows
                              className="bs-arrow-after-suregery"
                              size={20}
                            />
                          </div> */}
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    )}
                    {active === 1 && (
                      <Swiper
                        className="mySwiper"
                        autoplay={{
                          delay: 2500,
                          disableOnInteraction: false,
                        }}
                        modules={[Autoplay]}
                      >
                        {gyno.map((item) => (
                          <SwiperSlide>
                            <img
                              src={item.url}
                              className="ltx-ba-before"
                              alt="Face surgery"
                            />
                            {/* <div className="handle">
                            <BsArrows
                              className="bs-arrow-after-suregery"
                              size={20}
                            />
                          </div> */}
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    )}
                    {active === 2 && (
                      <Swiper
                        className="mySwiper"
                        autoplay={{
                          delay: 2500,
                          disableOnInteraction: false,
                        }}
                        modules={[Autoplay]}
                      >
                        {lipo.map((item) => (
                          <SwiperSlide>
                            <img
                              src={item.url}
                              className="ltx-ba-before"
                              alt="Face surgery"
                            />
                            {/* <div className="handle">
                            <BsArrows
                              className="bs-arrow-after-suregery"
                              size={20}
                            />
                          </div> */}
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    )}
                    {active === 3 && (
                      <Swiper
                        className="mySwiper"
                        autoplay={{
                          delay: 2500,
                          disableOnInteraction: false,
                        }}
                        modules={[Autoplay]}
                      >
                        {ortho.map((item) => (
                          <SwiperSlide>
                            <img
                              src={item.url}
                              className="ltx-ba-before"
                              alt="Face surgery"
                            />
                            {/* <div className="handle">
                            <BsArrows
                              className="bs-arrow-after-suregery"
                              size={20}
                            />
                          </div> */}
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    )}
                  </div>
                  {/* <div
                    className="ltx-ba-wrap ltx-ba-filter-0 active"
                    style={{ display: "block" }}
                  >
                  
                    <img
                      src="/Images/raf.jpeg"
                      className="ltx-ba-before"
                      alt="Face surgery"
                    />
                    <div className="handle">
                      <BsArrows className="bs-arrow-after-suregery" size={20} />
                    </div>
                  </div> */}
                </div>
                <div className="col-lg-3 hidden-md hidden-sm hidden-ms hidden-xs procedure-surgeryy">
                  <h6 className="header">
                    after <span> procedures </span>
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        style={{ padding: "40px 0px", background: "#edebeb" }}
        className="some-sample-after-before"
      >
        <Container>
          <Row>
            <Col md={2}>
              <h5
                style={{
                  fontSize: "25px",
                  fontWeight: "600",
                  color: "#0f80a5",
                  marginTop: "5px",
                }}
              >
                <span>View Some</span> <br />
                amazing photos from the gallery
              </h5>
            </Col>
            <Col md={10}>
              <div className="row centered">
                {" "}
                {dataImage.map((item) => (
                  <Col md={2}>
                    <div className="item">
                      <a className="swipebox photo">
                        <img
                          width={755}
                          height={500}
                          src={item.url}
                          className="attachment-holamed-gallery size-holamed-gallery"
                          style={{
                            width: "100%",
                            height: "120px",
                            objectFit: "cover",
                            borderRadius: "10px",
                          }}
                        />
                        <span className="fa fa-search" />
                      </a>
                    </div>
                  </Col>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default AfterSurgery;
